// import React, { useState } from 'react';
// import Logo from '../../assets/Logo.svg';
// import bgImage from "../../assets/back.png";
// import { Link } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// const SignupPassword = () => {
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//     const navigate = useNavigate();
//   return (
//     <div
//       className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
//       style={{ backgroundImage: `url(${bgImage})` }}
//     >
//       <div className="flex flex-col items-center relative">
//         <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

//         <div className="bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[490px] ps-8 pe-8 pb-8 pt-4 text-center">
//           <h2 className="text-2xl font-bold font-inter text-[#2D0076] font-[32px] text-gray-900">Welcome</h2>
//           <p className="text-sm font-nunito text-[#202224] font-600 mb-6">
//             Create Your Company Dispatcher Account
//           </p>

//           <form onSubmit={(e) => {
//     e.preventDefault();
//     navigate('/verifyotp'); 
//   }} >
//             <div className="text-left mb-4">
//               <label className="block font-[18px] text-[#20224] mb-1">Password</label>
//               <input
//                 type="password"
//                 placeholder="Create a password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="w-full px-4 py-2 border bg-[#F1F4F9] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//               />
//             </div>

//             <div className="text-left mb-4">
//               <label className="block font-[18px] text-[#20224] mb-1">Confirm Password</label>
//               <input
//                 type="password"
//                 placeholder="Re-enter password"
//                 value={confirmPassword}
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//                 className="w-full px-4 py-2 border bg-[#F1F4F9] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//               />
//             </div>

//             <button
//               type="submit"
//               className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition"
//             >
//               Next
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignupPassword;
import React, { useState } from 'react';
import Logo from '../../assets/Logo.svg';
import bgImage from "../../assets/back.png";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { faArrowLeft, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { registerCompany, forgetPassword } from '../../ApiController/ApiService';
import Swal from 'sweetalert2';

const SignupPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve data from Signup.jsx
  const { fullName, firstName, lastName, mobileNumber, email } = location.state || {};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validate passwords
    if (!password || !confirmPassword) {
      setError('Please enter both password and confirm password.');
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      setLoading(false);
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters long.');
      setLoading(false);
      return;
    }

    // Ensure all required data is present
    if (!fullName || !firstName || !mobileNumber || !email) {
      setError('Missing required registration data. Please go back and fill out all fields.');
      setLoading(false);
      return;
    }

    const data = {
      fullName,
      firstName,
      lastName: lastName || "",
      mobileNumber,
      email,
      password,
      userType:'COMPANY'
    };

    try {
      // Register the company
      const result = await registerCompany(data);
      console.log("Registration Success:", result);

      // Call forgetPassword API to get OTP
      const forgetPasswordResult = await forgetPassword({ email });
      console.log("Forget Password Success:", forgetPasswordResult);

      // Navigate to OTP verification page with email and OTP
      navigate('/verifyotp', { state: { email, otp: forgetPasswordResult.data.otp } });
    } catch (error) {
      setError(error.message || 'Registration failed. Please try again.');
      console.error("Registration Error:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="flex flex-col items-center relative">
        <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

        <div className="relative bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[490px] ps-8 pe-8 pb-8 pt-4 text-center">
          <button
            onClick={() => navigate(-1)}
            className="absolute top-4 left-4 text-[#2D0076] text-xl hover:text-[#6F1AFF] transition"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>

          <h2 className="text-2xl font-bold font-inter text-[#2D0076] text-gray-900">Welcome</h2>
          <p className="text-sm font-nunito text-[#202224] font-600 mb-6">
            Create Your Company Dispatcher Account
          </p>

          {error && (
            <p className="text-red-500 text-sm mb-4">{error}</p>
          )}

          <form onSubmit={handleSubmit}>
            <div className="text-left mb-4 relative">
              <label className="block font-[18px] text-[#202224] mb-1">Password</label>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Create a password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-2 border bg-[#F1F4F9] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
              >
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
              </button>
            </div>

            <div className="text-left mb-4 relative">
              <label className="block font-[18px] text-[#202224] mb-1">Confirm Password</label>
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder="Re-enter password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="w-full px-4 py-2 border bg-[#F1F4F9] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 pr-10"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
              >
                <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} />
              </button>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition disabled:opacity-50"
            >
              {loading ? "Submitting..." : "Next"}
            </button>
          </form>

          <p className="text-[#00217A] font-[20px] mt-6">
            Have an account? <Link to="/login" className="text-[#00217A] font-[20px] font-bold hover:underline">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignupPassword;